<template>
  <div
    class="mb-2"
    v-for="embedding in embeddings"
    :key="embedding.id"
  >
    <WorkerRunSummary
      multiline
      :worker-run-details="embedding.worker_run"
    />
  </div>
  <div
    class="loader is-size-3 mx-auto"
    v-if="loading"
  ></div>
  <div
    class="notification is-danger"
    v-else-if="errorMessage"
  >
    {{ errorMessage }}
  </div>
  <div
    class="notification is-warning"
    v-else-if="!embeddings.length"
  >
    There are no embeddings on this element.
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import WorkerRunSummary from '@/components/Process/Workers/WorkerRuns/WorkerRunSummary.vue'
import { errorParser } from '@/helpers'
import { useEmbeddingStore } from '@/stores/embedding'
import type { UUID } from '@/types'
import type { Embedding } from '@/types/embedding'

const { elementId } = defineProps<{ elementId: UUID }>()

const embeddingStore = useEmbeddingStore()

const loading = ref(false)
const errorMessage = ref('')
const embeddings = computed((): Embedding[] => embeddingStore.embeddings[elementId] ?? [])

watch(
  () => elementId,
  async (newValue: UUID) => {
    loading.value = true
    errorMessage.value = ''
    try {
      await embeddingStore.list(newValue)
    } catch (error) {
      errorMessage.value = errorParser(error)
    } finally {
      loading.value = false
    }
  },
  { immediate: true },
)
</script>
